import Waiting from '@/store/waiting';
import SfBaseActions from './sf_base';

export default class SfAccountActions extends SfBaseActions {
  constructor(Api, types) {
    super();
    const actions = {
      searchSfAccountByNameAction: this.SalesForceBaseAction(({ commit }, args) => {
        return waiting.check('searchSfAccountByNameAction', async () => {
          try {
            const result = await Api.searchSfAccountByName(args);
            return result.data.sfAccounts;
          } catch (err) {
            console.error(err);
            throw err;
          }
        });
      }),
      getSfAccountAction: this.SalesForceBaseAction(({ commit }, args) => {
        return waiting.check('getSfAccountAction', async () => {
          try {
            const result = await Api.getSfAccount(args);
            return result.data.sfAccount;
          } catch (err) {
            throw err;
          }
        });
      }),
    };
    const waiting = new Waiting(actions);
    this.actions = actions;
  }
}
